<template>
  <v-container fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card>
          <v-card-title class="d-flex align-center">
            <h3 class="text-h5 mb-0">Inloggen</h3>
            <v-spacer />
            <v-icon>lock_open</v-icon>
          </v-card-title>
          <v-card-text>
            <v-form ref="formRef" v-model="isFormValid">
              <v-text-field
                v-model="form.email"
                label="E-mail"
                :error-messages="emailErrors"
                required
                variant="outlined"
                @input="validateEmail"
                @blur="validateEmail"
              ></v-text-field>

              <v-text-field
                v-model="form.password"
                type="password"
                label="Wachtwoord"
                :error-messages="passwordErrors"
                required
                variant="outlined"
                @input="validatePassword"
                @blur="validatePassword"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              :loading="isLoading"
              :disabled="isLoading || !isFormValid"
              block
              color="green"
              type="submit"
              @click="handleSubmit"
            >
              Inloggen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref, reactive } from "vue";
import { useAuthStoreRefactor } from "@/stores/authStoreRefactor";
import { useAlertStore } from "@/stores/alertStore";
import { useRouter } from "vue-router";

export default {
  name: "LoginLegacyForm",
  setup() {
    const authStore = useAuthStoreRefactor();
    const alertStore = useAlertStore();
    const router = useRouter();

    const formRef = ref(null);
    const form = reactive({
      email: "",
      password: "",
    });
    const isFormValid = ref(false);
    const isLoading = ref(false);
    const emailErrors = ref([]);
    const passwordErrors = ref([]);
    const emailTouched = ref(false);
    const passwordTouched = ref(false);

    const validateEmail = () => {
      emailTouched.value = true;
      emailErrors.value = [];

      if (!form.email) {
        emailErrors.value.push("E-mail is verplicht");
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
        emailErrors.value.push("Voer een geldig e-mailadres in");
      }

      updateFormValidity();
    };

    const validatePassword = () => {
      passwordTouched.value = true;
      passwordErrors.value = [];

      if (!form.password) {
        passwordErrors.value.push("Wachtwoord is verplicht");
      } else if (form.password.length < 6) {
        passwordErrors.value.push(
          "Wachtwoord moet minimaal 6 tekens lang zijn",
        );
      }

      updateFormValidity();
    };

    const updateFormValidity = () => {
      isFormValid.value =
        emailTouched.value &&
        passwordTouched.value &&
        emailErrors.value.length === 0 &&
        passwordErrors.value.length === 0;
    };

    const validateForm = () => {
      validateEmail();
      validatePassword();
      return isFormValid.value;
    };

    const handleSubmit = async () => {
      if (!validateForm()) return;

      try {
        isLoading.value = true;
        await authStore.login(form);
        router.push("/");
      } catch (error) {
        console.error("Error logging in:", error);
        alertStore.setAlert(
          "Er is een fout opgetreden bij het inloggen",
          "error",
        );
      } finally {
        isLoading.value = false;
      }
    };

    return {
      formRef,
      form,
      isFormValid,
      isLoading,
      emailErrors,
      passwordErrors,
      validateEmail,
      validatePassword,
      handleSubmit,
    };
  },
};
</script>

<style scoped></style>
